import { GroupAttributes } from 'src/components/organisms';
import { Parameter, ParameterBaseProps } from './Parameter';
import { useMemo } from 'react';
type GroupParameterProps = ParameterBaseProps & {
  attributes: GroupAttributes;
};

export const GroupParameter = (props: GroupParameterProps) => {
  const { parameterOptions, parameterList } = props;

  const availableParameterOptions = useMemo(() => {
    return parameterOptions.filter(
      (option) => !Object.keys(parameterList).includes(`${option.value}`),
    );
  }, [parameterList, parameterOptions]);

  return (
    <Parameter {...props} options={availableParameterOptions} isSearchable />
  );
};
